// packages/constants/src/inputs/contact.ts
/** Max length of a "contact us" / leave-a-message body (POST /contact-requests).
 *  Shared by the server schema AND the client forms so the client-side validation
 *  matches the server cap (no opaque server rejection of an over-length message). */
export const CONTACT_REQUEST_MAX_MESSAGE_LENGTH = 2000;
/** Max length of the optional subject line on a contact request. */
export const CONTACT_REQUEST_MAX_SUBJECT_LENGTH = 200;
